export const ACCESS_TOKEN_NAME = 'access_token';
export const OTP_ACCESS_TOKEN_NAME = 'access_token_OTP';
export const TEMPORARY_TOKEN = 'temporary_token';
export const WHITE_LABEL_AFFILIATE = 'white_label_affiliate';
export const IFRAME = 'iframe';
export const POTENTIAL_USER = 'potentialUser';
export const EMAIL = 'email';
export const PHONE = 'phone';
export const STARTED_FROM_DASHBOARD = 'startedFromDashboard';
export const REDIRECT_URL = 'redirectUrl';
export const ATTACH_DEMOGRAPHICS_TO_REDIRECT_URL =
  'attachDemographicsToRedirectUrl';
export const LANGUAGE = 'language';
export const ADDED_ADDRESS = 'addedAddress';
export const OVS_ORDER_ID = 'ovs_order_id';
export const CURRENT_AFFILIATE = 'currentAffiliate';

// Use sessionStorage for authentication tokens to prevent account merging
// when multiple users log in from the same device/browser
// sessionStorage is isolated per tab/window, ensuring each user session is separate
export const setTokenToLocalStorage = (token: string): void => {
  sessionStorage.setItem(ACCESS_TOKEN_NAME, token);
};

export const getTokenFromLocalStorage = (): string | null => {
  return sessionStorage.getItem(ACCESS_TOKEN_NAME);
};

export const removeTokenFromLocalStorage = (): void => {
  sessionStorage.removeItem(ACCESS_TOKEN_NAME);
};

export const setOTPTokenToLocalStorage = (token: string): void => {
  sessionStorage.setItem(OTP_ACCESS_TOKEN_NAME, token);
};

export const getOTPTokenFromLocalStorage = (): string | null => {
  return sessionStorage.getItem(OTP_ACCESS_TOKEN_NAME);
};

export const removeOTPTokenFromLocalStorage = (): void => {
  sessionStorage.removeItem(OTP_ACCESS_TOKEN_NAME);
};

// Temporary tokens should also use sessionStorage to prevent account merging
export const setTemporaryTokenToLocalStorage = (token: string): void => {
  sessionStorage.setItem(TEMPORARY_TOKEN, token);
};

export const getTemporaryTokenFromLocalStorage = (): string | null => {
  return sessionStorage.getItem(TEMPORARY_TOKEN);
};

export const removeTemporaryTokenFromLocalStorage = (): void => {
  sessionStorage.removeItem(TEMPORARY_TOKEN);
};

export const setItemToLocalStorage = (key: string, value: any) => {
  localStorage.setItem(key, JSON.stringify(value));
};

export const getItemFromLocalStorage = (key: string) => {
  const saved: string | null = localStorage.getItem(key);
  if (!saved) {
    return null;
  }
  try {
    return JSON.parse(saved);
  } catch {
    return null;
  }
};

export const removeItemsFromLocalStorage = (itemsToRemove: string[]) => {
  for (const item of itemsToRemove) {
    localStorage.removeItem(item);
  }
};

export const removeItemsFromLocalStorageWithExceptions = (
  excludedLocalStorageKeys: string[]
) => {
  // Iterate through all localStorage items
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);

    // Clear all localStorage items except excludedLocalStorageKeys
    if (key && !excludedLocalStorageKeys.includes(key)) {
      // Remove the item
      localStorage.removeItem(key);
    }
  }
};
